import { render, staticRenderFns } from "./changeUserInfo.vue?vue&type=template&id=ef313728&"
import script from "./changeUserInfo.vue?vue&type=script&lang=ts&"
export * from "./changeUserInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports